import styled from 'styled-components';

export default styled.h1`
font-family:system-ui, Sans-serif;
font-weight: 300;
font-size: 42px;
color:white;
margin:0;
`;
